let careerForm = document.getElementById("careerForm");

if (careerForm) {
    let careerFormToggle = document.getElementById("careerFormToggle");
    let careerApplyBtn = document.querySelector(".button__apply");

    if (careerFormToggle)
        careerFormToggle.addEventListener("click", function () {
            careerForm.parentElement.classList.toggle("h-0");

            //hide buttons
            careerFormToggle.classList.add("hidden");
            if (careerApplyBtn) {
                careerApplyBtn.classList.add("hidden");
            }
        });

    window.addEventListener("message", function (e) {
        Object.hasOwn(e.data, "FrameHeight")
            ? setIframeHeight(e.data.FrameHeight)
            : "formSubmitted" === e.data
            ? careerForm.removeAttribute("height")
            : "iframeLoaded" === e.data && triggerIframeHeightCalculation();
    });

    let setIframeHeight = (e) => {
        careerForm.setAttribute("height", e);
    };

    let triggerIframeHeightCalculation = function () {
        careerForm.removeAttribute("height");
        careerForm.contentWindow.postMessage("FrameHeight", "*");
    };
}
